var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Department_props;
export class Department {
    constructor(props) {
        _Department_props.set(this, void 0);
        __classPrivateFieldSet(this, _Department_props, props, "f");
    }
    get id() {
        return __classPrivateFieldGet(this, _Department_props, "f").schema.departmentId || 0;
    }
    get countryId() {
        return __classPrivateFieldGet(this, _Department_props, "f").schema.countryId || 0;
    }
    get name() {
        return __classPrivateFieldGet(this, _Department_props, "f").schema.name || '';
    }
    get code() {
        return __classPrivateFieldGet(this, _Department_props, "f").schema.code || '';
    }
    get enabled() {
        return __classPrivateFieldGet(this, _Department_props, "f").schema.enabled || false;
    }
    get telephoneCode() {
        return __classPrivateFieldGet(this, _Department_props, "f").schema.telephoneCode || '';
    }
    get cities() {
        const departmentId = this.id;
        return __classPrivateFieldGet(this, _Department_props, "f").sdk.Cities.where(x => x.departmentId == departmentId);
    }
    get country() {
        return __classPrivateFieldGet(this, _Department_props, "f").sdk.Countries.firstOrDefault(x => x.id == this.countryId);
    }
    fluentUi() {
        return {
            key: this.id,
            text: this.name
        };
    }
}
_Department_props = new WeakMap();
